<template>
  <Card class="integration-vitec-basic" tag="form" @submit.prevent="submit">
    <template #header>
      <slot name="header" />
    </template>
    <template #default>
      <InputComponent
        v-model="value['account']"
        required
        prefix="https://"
        :label="labels['account']"
        :is-valid="validator.fields['account'].valid"
        :validation-message="validator.fields['account'].error"
      />
      <InputComponent
        v-model="value['id']"
        required
        :label="labels['id']"
        :is-valid="validator.fields['id'].valid"
        :validation-message="validator.fields['id'].error"
      />
      <InputComponent
        v-model="value['token']"
        :label="labels['token']"
        required
        :is-valid="validator.fields['token'].valid"
        :validation-message="validator.fields['token'].error"
      />
      <Alert>
        Fyll inn informasjon sendt per mail:&nbsp;
        <a target="_blank" href="https://help.kvass.no/nb/articles/14534">Les mer om oppsett av integrasjon her</a>
      </Alert>
    </template>
    <template #footer>
      <Alert v-if="error" theme="error" class="integration-vitec-basic__error">{{ error }}</Alert>
      <ButtonComponent
        :label="error ? 'Prøv igjen' : 'Neste'"
        theme="primary"
        :promise="promise"
        :disabled="!validator.passes"
        :icon="['fal', 'arrow-to-right']"
      />
    </template>
  </Card>
</template>

<script>
import Validator from '@/mixins/validator-v2'
import Card from '@kvass/card'
import { InputComponent } from 'vue-elder-input'
import { ButtonComponent } from 'vue-elder-button'
import { AlertComponent as Alert } from 'vue-elder-alert'
import { request } from '@/api/request'

const ValidatorSettings = {
  labels: {
    account: 'Konto URL',
    id: 'Integrasjons ID',
    token: 'Integrasjonsnøkkel',
  },
  rules: {
    account: 'required|domain',
    id: 'required',
    token: 'required',
  },
}

export { ValidatorSettings }
export default {
  mixins: [
    Validator({
      data: 'value',
      labels: 'labels',
      rules: 'rules',
    }),
  ],
  props: {
    value: Object,
  },
  data() {
    return {
      promise: null,
      error: null,
      labels: ValidatorSettings.labels,
      rules: ValidatorSettings.rules,
    }
  },
  methods: {
    submit() {
      if (!this.validator.passes) return

      this.error = null

      this.promise = request(`https://${this.value.account}/api/integration/${this.value.id}/callbacks/init`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.value.token}`,
        },
        mode: 'cors',
        body: JSON.stringify(this.$route.query),
      })
        .then(() => this.$emit('navigate', 'units'))
        .catch(err => {
          this.error = err
          throw err
        })
    },
  },
  components: {
    InputComponent,
    ButtonComponent,
    Card,
    Alert,
  },
}
</script>

<style lang="scss">
.integration-vitec-basic {
  max-width: 600px;

  .kvass-card__content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .alert p {
    margin-top: 0;
  }

  &__error {
    white-space: pre-line;
  }
}
</style>
